import React, { Component } from 'react'

import DatePicker  from 'react-widgets/lib/DatePicker'

class NLDatePicker extends Component {

  render() {
    return <DatePicker 
      format= 'DD-MM-YYYY'
      parse='D-M-YYYY'
      placeholder='DD-MM-YYYY'
      {...this.props}/>
  }
}

export default NLDatePicker